<template>
  <div v-for="(t, index) in barLinePositions" :key="index">
    <div v-if="!tooManyLines[1]">
      <v-line :config="{
        points: [0, t, chartWidth, t],
        stroke: '#000',
        strokeWidth: 3,
      }" />
      <div v-if="!tooManyLines[0]">
        <v-line v-for="(s, i) in subdivisionPositions" :config="{
          points: [0, t - s, chartWidth, t - s],
          stroke: '#000',
          strokeWidth: lastSubdivision.length * 0 + 1
        }" :key="i" />
      </div>
    </div>
  </div>
  <div v-if="!tooManyLines[0]">
    <v-line v-for="(t, i) in lastSubdivision" :config="{
      points: [0, t, chartWidth, t],
      stroke: '#000',
      strokeWidth: 1,
    }" :key="i" />
  </div>
</template>

<script setup>

import { computed, defineProps, inject, ref } from 'vue';
import { useChartRenderStore } from '../../stores/ChartRenderStore';

const mainChart = inject('chart')
const { orderedCL, columns } = mainChart
const mainChartRender = inject('chartRender')
const { chartWidth, clVisibleBeats } = mainChartRender

const chartRenderStore = useChartRenderStore() 

const props = defineProps({
  clIndex: {
    type: Number,
    required: true
  }
})

const cl = computed(() => orderedCL.value[props.clIndex])
const visibleBeats = computed(() => clVisibleBeats.value?.[props.clIndex])

const startPixel = computed(() => chartRenderStore.timeToPixel(cl.value.eventLine.time))
const timePerBeat = computed(() => 60 / cl.value.eventLine.bpm)
const pixelPerBeat = computed(() => chartRenderStore.timeToPixel(timePerBeat.value))

const barLinePositions = computed(() => {
  if (visibleBeats.value == null) return []

  const start = Math.trunc(visibleBeats.value[0])
  const end = Math.trunc(visibleBeats.value[1])
  return Array.from({ length: end - start }, (_, i) =>
    (start + i + 1) * pixelPerBeat.value + startPixel.value)
})

const subdivisionPositions = computed(() => {
  const pixelPerSubdivision = pixelPerBeat.value / chartRenderStore.subdivision
  return [...Array(chartRenderStore.subdivision - 1).keys()].map(x => (x + 1) * pixelPerSubdivision)
})

const lastSubdivision = computed(() => {
  if (visibleBeats.value == null) return []
  const endMod = (visibleBeats.value[1] % 1) * pixelPerBeat.value
  const endTrunc = Math.trunc(visibleBeats.value[1]) * pixelPerBeat.value

  const res = subdivisionPositions.value.filter(e => e < endMod).map(e => endTrunc + e + startPixel.value)
  return res
})

const tooManyLines = computed(() => {
  const lineDensity = cl.value.eventLine.bpm / chartRenderStore.zoomY
  return [chartRenderStore.subdivision * lineDensity >= 20000, lineDensity >= 20000]
})

</script>